module.exports = __webpack_public_path__ + "preschool.67122d7bc552a42aa305.jpg";


//////////////////
// WEBPACK FOOTER
// /home/hihoo/ibilling/attendence/public/src/assets/preschool.jpg
// module id = ../../../../../src/assets/preschool.jpg
// module chunks = 1